import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { useCallback, useState } from "react";
import {
  fetchTableProfile,
  TableProfilePayload,
} from "../../../../../../../api/postCall/fetchTableProfile";
import { logError } from "../../../../../../../utils/customLogger";

const DEFAULT_TABLE_PROFILE_PAYLOAD: TableProfilePayload = {
  dataset_name: "oncoemr",
  table_name: "cmm_input",
  created_at_cutoff_months: 3,
  top_values_limit: 10,
};

export const useTableProfile = () => {
  const [refreshing, setRefreshing] = useState(false);

  const refreshTableProfile = useCallback(async () => {
    setRefreshing(true);
    try {
      await fetchTableProfile(DEFAULT_TABLE_PROFILE_PAYLOAD);
      toast.success("Table profile refreshed successfully.");
    } catch (error) {
      logError(error as Error, "Error refreshing table profile");
      toast.error("Failed to refresh table profile. Please try again.");
    } finally {
      setRefreshing(false);
    }
  }, []);

  return {
    refreshing,
    refreshTableProfile,
  };
};
